module.exports = __webpack_public_path__ + "img/kwaiproPhone.ce4cdf7.png";